import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import Pagination from "../Constant/Pagination";
import { CancelRequest } from "../../services/AxiosInstance";
import DebounceSmallSearchInput from "../Constant/DebounceSmallSearchInput";
import { MdAdd } from "react-icons/md";
import { FiInfo } from "react-icons/fi";
import {
  deleteExpenseApi,
  getExpenseExportApi,
  getExpensesApi,
  updateExpenseApi,
} from "../../services/ExpenseService";
import { FaCheckCircle, FaDownload } from "react-icons/fa";
import AddExpenseModal from "./AddExpenseModal";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { toast } from "react-toastify";
import { IoClose } from "react-icons/io5";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import { Menu, MenuItem, ListItemIcon, Divider } from "@mui/material";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { FaMoneyCheck } from "react-icons/fa";
import { FaHistory } from "react-icons/fa";
import {
  dateRangeOptions,
  formatToIndianNumber,
  paymentStatusBadge,
  paymentStatusOption,
  useIsMobile,
} from "../../utilities";
import GlobalSearchableDropdown from "../Constant/SearchableDropdown";
import { TbBrandGoogleAnalytics } from "react-icons/tb";
import { FaRecycle } from "react-icons/fa6";
import { IoIosWarning } from "react-icons/io";
import DatePicker from "react-datepicker";
import { subDays, startOfMonth, endOfMonth, subMonths } from "date-fns";
import {
  getServiceCenterOptionApi,
  searchVendorApi,
} from "../../services/SearchService";
import { BiSolidFileExport } from "react-icons/bi";
import { Link } from "react-router-dom";
import { getExpenseReportApi } from "../../services/ReportService";
const paymentMethods = [
  { id: "cash", value: "CASH", label: "Cash" },
  { id: "card", value: "CARD", label: "Card" },
  { id: "cheque", value: "CHEQUE", label: "Cheque" },
  { id: "online", value: "ONLINE", label: "Online" },
  { id: "other", value: "OTHER", label: "Other" },
];

const Expense = () => {
  const userRole = useSelector((state) =>
    state.auth.user?.is_superuser ? "admin" : "user" || ""
  );
  const isMobile = useIsMobile();
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
  const [anchorEl, setAnchorEl] = useState(null);
  const actionMenuOpen = Boolean(anchorEl);
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [expenseDeleteModal, setExpenseDeleteModal] = useState(false);
  const [deleteLoading, setdeleteLoading] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [paymentHistoryModal, setPaymentHistoryModal] = useState(false);
  const [selectedStatus, setSelecetdStatus] = useState(null);
  const [vendorOption, setvendorOption] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [selectedDate, setSelectedDate] = useState(dateRangeOptions[4]);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [serviceCenterOption, setServiceCenterOption] = useState([]);
  const [selecetdServiceCenter, setSelectedServiceCenter] = useState(null);
  const [exportLoading, setExportLoading] = useState(false);
  const [expenseSummary, setExpenseSummary] = useState({
    total_expenses: 0,
    paid_amount: 0,
    unpaid_amount: 0,
    partial_paid_amount: 0,
  });
  const [param, setParam] = useState({
    page: "1",
    page_size: "10",
    query: "",
    start_date: format(subDays(new Date(), 30), "yyyy-MM-dd"),
    end_date: format(new Date(), "yyyy-MM-dd"),
    vendor_id: "",
    payment_status: "",
    service_center_id: "",
  });
  const [paymentForm, setPaymentForm] = useState({
    paid_amount: "",
    date: new Date().toISOString().split("T")[0],
    payment_method: "CASH",
    reference_id: "",
  });
  const [paymentFormError, setPaymentFormError] = useState({});

  useEffect(() => {
    const vendor = selectedVendor?.value || "";
    const status = selectedStatus?.value || "";
    const serviceCenter = selecetdServiceCenter?.value || "";
    if (
      param?.vendor_id !== vendor ||
      param?.payment_status !== status ||
      param?.service_center_id !== serviceCenter
    ) {
      setParam({
        ...param,
        vendor: vendor,
        payment_status: status,
        service_center_id: serviceCenter,
      });
    }
  }, [selectedVendor, selectedStatus, selecetdServiceCenter]);
  const handleActionClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setSelectedExpense(item);
  };

  const handleActionClose = () => {
    setAnchorEl(null);
  };
  const handleToggleDelete = () => {
    if (expenseDeleteModal) {
      setSelectedExpense(null);
    }
    setExpenseDeleteModal(!expenseDeleteModal);
  };
  const handleTogglePaymentHistoryModal = () => {
    if (paymentHistoryModal) {
      setSelectedExpense(null);
    }
    setPaymentHistoryModal(!paymentHistoryModal);
  };
  const handleToggleAddModal = () => {
    setSelectedExpense(null);
    setAddModal(!addModal);
  };
  const handleEditModal = () => {
    if (addModal) {
      setSelectedExpense(null);
    }
    setAddModal(!addModal);
  };
  const handleTogglePaymentModal = () => {
    if (paymentModal) {
      setSelectedExpense(null);
    } else {
      setPaymentForm({
        paid_amount: "",
        date: new Date().toISOString().split("T")[0],
        payment_method: "CASH",
        reference_id: "",
      });
      setPaymentFormError({});
    }

    setPaymentModal(!paymentModal);
  };
  const deleteExpense = () => {
    setdeleteLoading(true);
    deleteExpenseApi(selectedExpense?.id || "")
      .then((res) => {
        toast.success("Delete Successfully");
        handleToggleDelete();
        getData();
      })
      .finally(() => {
        setdeleteLoading(false);
      });
  };
  
  const getData = () => {
    setLoading(true);
    getExpensesApi(param)
      .then((res) => {
        setError("");
        setData(res?.data?.results?.expenses || []);
        setExpenseSummary(res?.data?.results?.summary || null);
        setTotal(res?.data?.results?.count || 0);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getData();
  }, [param]);
  const getVendor = () => {
    searchVendorApi()
      .then((res) => {
        const option = res?.data?.results || [];
        setvendorOption(option);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };
  const getServiceCenter = () => {
    getServiceCenterOptionApi()
      .then((res) => {
        const option = res?.data?.results || [];
        setServiceCenterOption(option);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };
  useEffect(() => {
    getVendor();
    if (userRole == "admin") {
      getServiceCenter();
    }
  }, []);
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };

  const handleAfterExpenseAdd = () => {
    handleToggleAddModal();
    getData();
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setPaymentForm((prev) => ({ ...prev, [name]: value }));
    if (name === "paid_amount") {
      const remaining =
        Number(selectedExpense?.amount || 0) -
        Number(selectedExpense?.paid_amount || 0);

      if (!value) {
        setPaymentFormError((prev) => ({ ...prev, paid_amount: "" }));
      } else if (Number(value) > remaining) {
        setPaymentFormError((prev) => ({
          ...prev,
          paid_amount: `Paid amount should be less than or equal to ${remaining}`,
        }));
      } else {
        setPaymentFormError((prev) => ({
          ...prev,
          paid_amount: "",
        }));
      }
    } else {
      if (value && paymentFormError?.[name]) {
        setPaymentFormError((prev) => ({ ...prev, [name]: "" }));
      }
    }
  };
  const handlePaymentSubmit = () => {
    let error = {};
    if (!paymentForm.payment_method) error.payment_method = "Required Field";
    if (!paymentForm.date) error.date = "Required Field";
    if (!paymentForm.paid_amount) {
      error.paid_amount = "Required Field";
    } else if (
      Number(paymentForm.paid_amount) >
      Number(selectedExpense?.amount || 0) -
        Number(selectedExpense?.paid_amount || 0)
    ) {
      error.paid_amount = `Paid amount should less than or equal to ${
        Number(selectedExpense?.amount || 0) -
        Number(selectedExpense?.paid_amount || 0)
      }`;
    }
    if (
      ["CARD", "CHEQUE", "ONLINE", "OTHER"].includes(
        paymentForm?.payment_method
      )
    ) {
      if (!paymentForm?.reference_id) {
        error.reference_id = "Required Field";
      }
    }

    setPaymentFormError(error);

    if (Object.keys(error).length === 0) {
      let payload = {
        payment_amount: paymentForm?.paid_amount || "",
        payment_date: paymentForm?.date || "",
        payment_mode: paymentForm?.payment_method || "",
      };

      if (
        ["CARD", "CHEQUE", "ONLINE", "OTHER"].includes(
          paymentForm?.payment_method
        )
      ) {
        payload.reference_id = paymentForm?.reference_id || "";
      }

      handlePayment(payload);
    }
  };

  const handlePayment = (payload) => {
    setPaymentLoading(true);
    updateExpenseApi(selectedExpense?.id || "", payload)
      .then(() => {
        toast.success("Payment update successfully");
        handleTogglePaymentModal();
        getData();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => setPaymentLoading(false));
  };
  const handleDateRangeChange = (option) => {
    setSelectedDate(option);
    if (!option) {
      setParam({
        ...param,
        start_date: "",
        end_date: "",
        page: "1",
      });
      return;
    }
    let startDate,
      endDate = new Date();
    switch (option.value) {
      case "today":
        startDate = new Date();
        endDate = new Date();
        break;
      case "yesterday":
        startDate = subDays(new Date(), 1);
        endDate = startDate;
        break;
      case "7_days":
        startDate = subDays(new Date(), 7);
        break;
      case "15_days":
        startDate = subDays(new Date(), 15);
        break;
      case "30_days":
        startDate = subDays(new Date(), 30);
        break;
      case "last_month":
        startDate = startOfMonth(subMonths(new Date(), 1));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "3_months":
        startDate = startOfMonth(subMonths(new Date(), 3));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "custom":
        setShowDatePicker(true);
        return;
      default:
        return;
    }
    setShowDatePicker(false);
    setParam({
      ...param,
      start_date: format(startDate, "yyyy-MM-dd"),
      end_date: format(endDate, "yyyy-MM-dd"),
      page: "1",
    });
  };

  const getValueByKey = (obj, key) => {
    return key
      .split(".")
      .reduce((acc, part) => (acc ? acc[part] : undefined), obj);
  };
  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <FaSort className="sort-icon neutral" />;
    }
    return sortConfig.direction === "asc" ? (
      <FaSortUp className="sort-icon active" />
    ) : (
      <FaSortDown className="sort-icon active" />
    );
  };
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sorted = [...data].sort((a, b) => {
      const valA = getValueByKey(a, key);
      const valB = getValueByKey(b, key);

      const numA = parseFloat(valA);
      const numB = parseFloat(valB);
      const dateA = Date.parse(valA);
      const dateB = Date.parse(valB);

      // Numeric sort if both are valid numbers
      if (!isNaN(numA) && !isNaN(numB)) {
        return direction === "asc" ? numA - numB : numB - numA;
      }

      // Date sort if both are valid dates
      if (!isNaN(dateA) && !isNaN(dateB)) {
        return direction === "asc" ? dateA - dateB : dateB - dateA;
      }

      // Fallback to string sort (letters, "inf", etc.)
      return direction === "asc"
        ? String(valA).localeCompare(String(valB), undefined, {
            sensitivity: "base",
          })
        : String(valB).localeCompare(String(valA), undefined, {
            sensitivity: "base",
          });
    });

    setData(sorted);
  };

  const handleExport = () => {
    setExportLoading(true);
    getExpenseExportApi({ ...param, export: true })
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "Expense-report.xlsx";

        // Append to DOM to make it more consistent
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setExportLoading(false);
      });
  };
  return (
    <div>
      <div className="card mb-3">
        <div className="d-flex justify-content-between align-items-start gap-2 flex-start p-3 flex-wrap">
          <div className="d-flex flex-column">
            <h5 className="mb-0">Expense Summary</h5>
            <span
              className="text-dark fw-medium"
              style={{ fontSize: "0.8rem" }}
            >
              Manage your expenses
            </span>
          </div>
          <div className="d-flex gap-2">
            <div>
              <div>
                <button
                  className="btn btn-primary px-2"
                  onClick={handleToggleAddModal}
                  // style={{ padding: "0.45rem 0" }}
                >
                  <MdAdd className="me-1" size="20" />
                  Add Expenses
                </button>
              </div>
            </div>
            {userRole !== "user" && (
              <button
                className="btn btn-success"
                disabled={exportLoading || data?.length == 0}
                onClick={handleExport}
              >
                {exportLoading ? (
                  <Spinner size="sm me-1" animation="border" />
                ) : (
                  <FaDownload className="me-1" />
                )}
                Export
              </button>
            )}
          </div>
        </div>

        <div className="row g-3 p-3">
          <div className="col-6 col-lg-3">
            <div
              className="card shadow-sm rounded-4 h-100 overflow-hidden"
              style={{
                background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 20px rgba(0, 0, 0, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(0, 0, 0, 0.1)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-15%",
                  right: "-15%",
                  width: "140px",
                  height: "140px",
                  background:
                    "linear-gradient(135deg, rgba(239, 68, 68, 0.15), rgba(254, 202, 202, 0.1))",
                  borderRadius: "50%",
                  filter: "blur(50px)",
                  opacity: "0.7",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: "-20%",
                  left: "-20%",
                  width: "120px",
                  height: "120px",
                  background:
                    "linear-gradient(135deg, rgba(239, 68, 68, 0.12), rgba(254, 202, 202, 0.08))",
                  borderRadius: "50%",
                  filter: "blur(40px)",
                  opacity: "0.5",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "4px",
                  background: "linear-gradient(90deg, #ef4444, #f87171)",
                  borderRadius: "4px 4px 0 0",
                }}
              ></div>
              <div
                className={`card-body d-flex justify-content-between align-items-center ${
                  isMobile ? "p-3" : "p-4"
                }`}
              >
                <div>
                  <h5
                    className="fw-bold m-0 text-primary"
                    style={{ fontSize: "1.2rem" }}
                  >
                    ₹{formatToIndianNumber(expenseSummary?.total_expenses || 0)}
                  </h5>
                  <span className="fw-medium" style={{ fontSize: "0.85rem" }}>
                    Total Expense
                  </span>
                </div>
                <span
                  className="d-none rounded-3 d-sm-flex justify-content-center align-items-center"
                  style={{
                    padding: "0.7rem",
                    background: "linear-gradient(135deg, #ef4444, #f87171)",
                    boxShadow: "0 6px 15px rgba(239, 68, 68, 0.3)",
                  }}
                >
                  <TbBrandGoogleAnalytics size={22} color="white" />
                </span>
              </div>
            </div>
          </div>

          <div className="col-6 col-lg-3">
            <div
              className="card shadow-sm rounded-4 h-100 overflow-hidden"
              style={{
                background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 20px rgba(0, 0, 0, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(0, 0, 0, 0.1)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-15%",
                  left: "-15%",
                  width: "140px",
                  height: "140px",
                  background:
                    "linear-gradient(135deg, rgba(34, 197, 94, 0.15), rgba(187, 247, 208, 0.1))",
                  borderRadius: "50%",
                  filter: "blur(50px)",
                  opacity: "0.7",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: "-20%",
                  right: "-20%",
                  width: "120px",
                  height: "120px",
                  background:
                    "linear-gradient(135deg, rgba(34, 197, 94, 0.12), rgba(187, 247, 208, 0.08))",
                  borderRadius: "50%",
                  filter: "blur(40px)",
                  opacity: "0.5",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "4px",
                  background: "linear-gradient(90deg, #16a34a, #22c55e)",
                  borderRadius: "4px 4px 0 0",
                }}
              ></div>
              <div
                className={`card-body d-flex justify-content-between align-items-center ${
                  isMobile ? "p-3" : "p-4"
                }`}
              >
                <div>
                  <h5
                    className="fw-bold m-0"
                    style={{ fontSize: "1.2rem", color: "#14532d" }}
                  >
                    ₹{formatToIndianNumber(expenseSummary?.paid_amount || 0)}
                  </h5>
                  <span className="fw-medium" style={{ fontSize: "0.8rem" }}>
                    Paid Amount
                  </span>
                </div>
                <span
                  className="d-none rounded-3 d-sm-flex justify-content-center align-items-center"
                  style={{
                    padding: "0.7rem",
                    background: "linear-gradient(135deg, #16a34a, #22c55e)",
                    boxShadow: "0 4px 10px rgba(22, 163, 74, 0.3)",
                  }}
                >
                  <FaCheckCircle size={22} color="white" />
                </span>
              </div>
            </div>
          </div>

          <div className="col-6 col-lg-3">
            <div
              className="card shadow-sm rounded-4 h-100 overflow-hidden"
              style={{
                background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 20px rgba(0, 0, 0, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(0, 0, 0, 0.1)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-15%",
                  left: "-15%",
                  width: "140px",
                  height: "140px",
                  background:
                    "linear-gradient(135deg, rgba(234, 179, 8, 0.15), rgba(254, 243, 199, 0.1))",
                  borderRadius: "50%",
                  filter: "blur(50px)",
                  opacity: "0.7",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: "-20%",
                  right: "-20%",
                  width: "120px",
                  height: "120px",
                  background:
                    "linear-gradient(135deg, rgba(234, 179, 8, 0.12), rgba(254, 243, 199, 0.08))",
                  borderRadius: "50%",
                  filter: "blur(40px)",
                  opacity: "0.5",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "4px",
                  background: "linear-gradient(90deg, #eab308, #facc15)",
                  borderRadius: "4px 4px 0 0",
                }}
              ></div>
              <div
                className={`card-body d-flex justify-content-between align-items-center ${
                  isMobile ? "p-3" : "p-4"
                }`}
              >
                <div>
                  <h5
                    className="fw-bold m-0"
                    style={{ fontSize: "1.2rem", color: "#713f12" }}
                  >
                    ₹{formatToIndianNumber(expenseSummary?.unpaid_amount || 0)}
                  </h5>
                  <span className="fw-medium" style={{ fontSize: "0.8rem" }}>
                    Unpaid Amount
                  </span>
                </div>
                <span
                  className="d-none rounded-3 d-sm-flex justify-content-center align-items-center"
                  style={{
                    padding: "0.7rem",
                    background: "linear-gradient(135deg, #eab308, #facc15)",
                    boxShadow: "0 4px 10px rgba(234, 179, 8, 0.3)",
                  }}
                >
                  <IoIosWarning size={22} color="white" />
                </span>
              </div>
            </div>
          </div>

          <div className="col-6 col-lg-3">
            <div
              className="card shadow-sm rounded-4 h-100 overflow-hidden"
              style={{
                background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 20px rgba(0, 0, 0, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(0, 0, 0, 0.1)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-15%",
                  left: "-15%",
                  width: "140px",
                  height: "140px",
                  background:
                    "linear-gradient(135deg, rgba(59, 130, 246, 0.15), rgba(147, 197, 253, 0.1))",
                  borderRadius: "50%",
                  filter: "blur(50px)",
                  opacity: "0.7",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: "-20%",
                  right: "-20%",
                  width: "120px",
                  height: "120px",
                  background:
                    "linear-gradient(135deg, rgba(59, 130, 246, 0.12), rgba(147, 197, 253, 0.08))",
                  borderRadius: "50%",
                  filter: "blur(40px)",
                  opacity: "0.5",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "4px",
                  background: "linear-gradient(90deg, #0ea5e9, #38bdf8)",
                  borderRadius: "4px 4px 0 0",
                }}
              ></div>
              <div
                className={`card-body d-flex justify-content-between align-items-center ${
                  isMobile ? "p-3" : "p-4"
                }`}
              >
                <div>
                  <h5
                    className="fw-bold m-0"
                    style={{ fontSize: "1.2rem", color: "#075985" }}
                  >
                    ₹
                    {formatToIndianNumber(
                      expenseSummary?.partial_paid_amount || 0
                    )}
                  </h5>
                  <span className="fw-medium" style={{ fontSize: "0.8rem" }}>
                    Adjusted Amount
                  </span>
                </div>
                <span
                  className="d-none rounded-3 d-sm-flex justify-content-center align-items-center"
                  style={{
                    padding: "0.7rem",
                    background: "linear-gradient(135deg, #0ea5e9, #38bdf8)",
                    boxShadow: "0 4px 10px rgba(14, 165, 233, 0.3)",
                  }}
                >
                  <FaRecycle size={22} color="white" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="p-4 d-flex justify-content-between flex-wrap gap-2">
          <div className="d-flex gap-1 flex-fill flex-md-grow-0">
            <div className="flex-fill">
              <DebounceSmallSearchInput
                handleSearchChange={handleSearchChange}
              />
            </div>
          </div>
          <div className="d-flex gap-2 flex-wrap">
            {userRole == "admin" && (
              <div>
                <GlobalSearchableDropdown
                  options={serviceCenterOption}
                  selected={selecetdServiceCenter}
                  onSelect={(item) => setSelectedServiceCenter(item)}
                  placeholder="Service Center"
                />
              </div>
            )}

            <div>
              <GlobalSearchableDropdown
                options={vendorOption}
                selected={selectedVendor}
                onSelect={(item) => setSelectedVendor(item)}
                placeholder="Vendor"
              />
            </div>
            <div>
              <GlobalSearchableDropdown
                options={paymentStatusOption}
                selected={selectedStatus}
                onSelect={(item) => setSelecetdStatus(item)}
                placeholder="Status"
              />
            </div>
            {showDatePicker && (
              <div className="">
                <DatePicker
                  selectsRange
                  startDate={
                    param?.start_date ? new Date(param.start_date) : null
                  }
                  endDate={param?.end_date ? new Date(param.end_date) : null}
                  onChange={(update) => {
                    const [start, end] = update;
                    setParam((prev) => ({
                      ...prev,
                      start_date: start ? format(start, "yyyy-MM-dd") : "",
                      end_date: end ? format(end, "yyyy-MM-dd") : "",
                      page: 1,
                    }));
                  }}
                  isClearable
                  placeholderText="Select date range"
                  className="form-control"
                  style={{
                    fontSize: "0.5rem",
                  }}
                />
              </div>
            )}
            <div className="">
              <GlobalSearchableDropdown
                options={dateRangeOptions}
                selected={selectedDate}
                onSelect={(item) => handleDateRangeChange(item)}
                placeholder="Period"
              />
            </div>
          </div>
        </div>
        {loading ? (
          <div className="text-center my-4">
            <Spinner animation="border" />
          </div>
        ) : error ? (
          <div className="text-center my-4 text-danger">{error}</div>
        ) : data && data?.length > 0 ? (
          <div className="table-responsive">
            <table className="table fs-6 mb-0 align-middle">
              <thead className="table-light custom-thead">
                <tr>
                  <th
                    onClick={() => handleSort("category_name")}
                    style={{ cursor: "pointer" }}
                  >
                    Category{renderSortIcon("category_name")}
                  </th>
                  <th
                    onClick={() => handleSort("subcategory_name")}
                    style={{ cursor: "pointer" }}
                  >
                    SubCategory{renderSortIcon("subcategory_name")}
                  </th>
                  <th
                    onClick={() => handleSort("vendor_name")}
                    style={{ cursor: "pointer" }}
                  >
                    Vendor{renderSortIcon("vendor_name")}
                  </th>
                  <th
                    onClick={() => handleSort("description")}
                    style={{ cursor: "pointer" }}
                  >
                    Description{renderSortIcon("description")}
                  </th>
                  {userRole !== "user" && (
                    <th
                      onClick={() => handleSort("service_center_name")}
                      style={{ cursor: "pointer" }}
                    >
                      Service Center{renderSortIcon("service_center_name")}
                    </th>
                  )}

                  <th
                    onClick={() => handleSort("amount")}
                    style={{ cursor: "pointer" }}
                  >
                    Amount{renderSortIcon("amount")}
                  </th>
                  <th
                    onClick={() => handleSort("paid_amount")}
                    style={{ cursor: "pointer" }}
                  >
                    Paid Amount{renderSortIcon("paid_amount")}
                  </th>
                  <th
                    onClick={() => handleSort("payment_status")}
                    style={{ cursor: "pointer" }}
                  >
                    Status{renderSortIcon("payment_status")}
                  </th>
                  <th
                    onClick={() => handleSort("date")}
                    style={{ cursor: "pointer" }}
                  >
                    Date{renderSortIcon("date")}
                  </th>

                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((item, index) => (
                  <tr key={item.id}>
                    <td>{item?.category_name || "-"}</td>
                    <td>
                      <div>
                        {item?.subcategory_name || "-"}
                        {item?.lit && (
                          <span
                            className="ms-1 border-start ps-1"
                            style={{ fontSize: "0.75rem" }}
                          >
                            {item?.lit} Ltr
                          </span>
                        )}
                      </div>
                    </td>

                    <td>{item?.vendor_name || "-"}</td>
                    <td>{item?.description || "-"}</td>
                    {userRole !== "user" && (
                      <td>{item?.service_center_name || "-"}</td>
                    )}

                    <td>
                      {item?.amount
                        ? `₹${formatToIndianNumber(item?.amount)}`
                        : "-"}
                    </td>
                    <td>
                      {item?.paid_amount
                        ? `₹${formatToIndianNumber(item?.paid_amount)}`
                        : "-"}
                    </td>
                    <td>{paymentStatusBadge(item?.payment_status)}</td>

                    <td>
                      {item?.date
                        ? format(new Date(item?.date), "dd MMM yyy")
                        : "-"}
                    </td>

                    <td>
                      <IconButton
                        size="small"
                        onClick={(e) => handleActionClick(e, item)}
                        style={{ border: "1px solid #ddd" }}
                      >
                        <PiDotsThreeOutlineVerticalFill
                          className="text-dark"
                          size={13}
                        />
                      </IconButton>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center my-4">No data found</div>
        )}
        {!loading && data?.length > 0 && (
          <div className="p-4">
            <Pagination
              currentPage={param.page}
              recordsPage={param.page_size}
              dataLength={total}
              handlePagination={handlePageChange}
            />
          </div>
        )}
      </div>
      <AddExpenseModal
        data={selectedExpense || null}
        visible={addModal}
        onClose={handleToggleAddModal}
        onAfterSubmit={handleAfterExpenseAdd}
      />
      <Dialog
        maxWidth="xs"
        fullWidth
        open={expenseDeleteModal}
        onClose={handleToggleDelete}
      >
        <DialogContent className="p-2">
          <Box display="flex" alignItems="flex-start" gap={1}>
            <FiInfo size={20} color="#1976d2" style={{ marginTop: "4px" }} />
            <Typography variant="body1">
              Are you sure you want to delete{" "}
              <strong style={{ color: "red" }}>
                {selectedExpense?.category_name}
              </strong>
              ? This action cannot be undone.
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleToggleDelete}
            color="inherit"
            disabled={deleteLoading}
          >
            Cancel
          </Button>
          <Button color="error" variant="contained" onClick={deleteExpense}>
            {deleteLoading && <Spinner animation="border" size="sm" />}
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={paymentModal}
        onClose={handleTogglePaymentModal}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 2, overflow: "hidden" },
        }}
      >
        <DialogTitle
          className="d-flex justify-content-between align-items-center"
          sx={{ p: 2, pb: 1 }}
        >
          <div className="fw-semibold" style={{ fontSize: "0.95rem" }}>
            <span className="text-darker">Remaining Amount:</span>
            <span className="text-danger">
              ₹
              {formatToIndianNumber(
                Number(selectedExpense?.amount || 0) -
                  Number(selectedExpense?.paid_amount || 0) || 0
              )}
            </span>
          </div>
          <IconButton onClick={handleTogglePaymentModal} size="small">
            <IoClose size={20} />
          </IconButton>
        </DialogTitle>
        <DialogContent
          className="scroll-container"
          sx={{ p: 3, maxHeight: "80vh", overflowY: "auto" }}
        >
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label text-dark">
                Paid Amount<span className="ms-1 text-danger">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${
                  paymentFormError?.paid_amount ? "is-invalid" : ""
                }`}
                name="paid_amount"
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    handleInputChange(e);
                  }
                }}
                value={paymentForm?.paid_amount}
                placeholder="e.g. ₹4000"
              />
              {paymentFormError?.paid_amount && (
                <small className="text-danger">
                  {paymentFormError?.paid_amount}
                </small>
              )}
            </div>
            <div className="col-md-6">
              <label className="form-label text-dark">
                Payment Date <span className="ms-1 text-danger">*</span>
              </label>
              <input
                type="date"
                name="date"
                className={`form-control ${
                  paymentFormError?.date ? "is-invalid" : ""
                }`}
                onChange={handleInputChange}
                value={paymentForm?.date}
                max={new Date().toISOString().split("T")[0]}
              />
              {paymentFormError?.date && (
                <small className="text-danger">{paymentFormError?.date}</small>
              )}
            </div>
            <div className="col-12 d-flex flex-column">
              <label className="form-label text-dark mb-1">
                Payment Mode <span className="ms-1 text-danger">*</span>
              </label>
              <div className="d-flex gap-2 flex-wrap">
                {paymentMethods.map((method) => (
                  <div className="form-check form-check-inline" key={method.id}>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="payment_method"
                      id={method.id}
                      value={method.value}
                      checked={paymentForm.payment_method === method.value}
                      onChange={handleInputChange}
                    />
                    <label
                      className="form-check-label"
                      style={{ paddingLeft: "0.3rem" }}
                      htmlFor={method.id}
                    >
                      {method.label}
                    </label>
                  </div>
                ))}
              </div>
              {error?.payment_method && (
                <small className="text-danger">{error?.payment_method}</small>
              )}
            </div>
            {["CARD", "CHEQUE", "ONLINE", "OTHER"].includes(
              paymentForm?.payment_method
            ) && (
              <div className="col-md-6">
                <label className="form-label text-dark">
                  Payment Reference
                  <span className="ms-1 text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="reference_id"
                  className={`form-control ${
                    paymentFormError?.reference_id ? "is-invalid" : ""
                  }`}
                  value={paymentForm.reference_id}
                  onChange={handleInputChange}
                  placeholder="e.g. TXN123456789"
                />
                {paymentFormError?.reference_id && (
                  <small className="text-danger">
                    {paymentFormError.reference_id}
                  </small>
                )}
              </div>
            )}
          </div>

          <div className="border-top d-flex justify-content-end gap-1 pt-2 mt-2">
            <button
              className="btn btn-primary"
              onClick={handlePaymentSubmit}
              disabled={paymentLoading}
            >
              {paymentLoading && <Spinner animation="border" size="sm" />}
              Submit
            </button>
          </div>

          {selectedExpense?.payment_history?.length > 0 && (
            <div className="table-responsive mt-2">
              <table className="table table-sm fs-6 table-borderedless align-middle">
                <thead className="bg-light">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Paymnet Mode</th>
                    <th scope="col">Reference ID</th>
                    <th>Paymnet By</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedExpense?.payment_history?.map((item, index) => (
                    <tr key={item?.id}>
                      <td>{index + 1}</td>
                      <td>
                        {item?.amount
                          ? `₹${formatToIndianNumber(item?.amount)}`
                          : "-"}
                      </td>
                      <td>{item?.payment_mode || "-"}</td>
                      <td>{item?.reference_id || "-"}</td>
                      <td>{item?.created_by_name || "-"}</td>
                      <td>
                        {item?.created_at
                          ? format(item?.created_at, "dd MMM yyy")
                          : "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </DialogContent>
      </Dialog>

      <Dialog
        open={paymentHistoryModal}
        onClose={handleTogglePaymentHistoryModal}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 2, overflow: "hidden" },
        }}
      >
        <DialogTitle
          className="d-flex justify-content-between align-items-center border-bottom"
          sx={{ p: 2, pb: 1 }}
        >
          <span className="fw-medium" style={{ fontSize: "1.1rem" }}>
            Payment History
          </span>
          <IconButton onClick={handleTogglePaymentHistoryModal} size="small">
            <IoClose size={20} />
          </IconButton>
        </DialogTitle>
        <DialogContent
          className="m-0 px-2 scroll-container"
          sx={{ maxHeight: "80vh", overflowY: "auto" }}
        >
          {selectedExpense?.payment_history?.length > 0 ? (
            <div className="table-responsive mt-2">
              <table className="table table-sm fs-6 table-borderedless align-middle">
                <thead className="bg-light">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Paymnet Mode</th>
                    <th scope="col">Reference ID</th>
                    <th>Paymnet By</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedExpense?.payment_history?.map((item, index) => (
                    <tr key={item?.id}>
                      <td>{index + 1}</td>
                      <td>{item?.amount || "-"}</td>
                      <td>{item?.payment_mode || "-"}</td>
                      <td>{item?.reference_id || "-"}</td>
                      <td>{item?.created_by_name || "-"}</td>
                      <td>
                        {item?.created_at
                          ? format(item?.created_at, "dd MMM yyy")
                          : "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center text-dark">No Record Found</div>
          )}
        </DialogContent>
      </Dialog>

      <Menu
        anchorEl={anchorEl}
        open={actionMenuOpen}
        onClose={handleActionClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          style: {
            borderRadius: "6px", // lighter radius
            padding: "0.15rem 0",
            minWidth: "130px",
            boxShadow: "0px 2px 6px rgba(0,0,0,0.2)", // very light shadow
          },
        }}
      >
        {userRole == "admin" && (
          <MenuItem
            onClick={() => {
              handleTogglePaymentModal();
              handleActionClose();
            }}
            sx={{ padding: "5px 14px", fontSize: "0.85rem" }}
          >
            <ListItemIcon>
              <FaMoneyCheck size={14} />
            </ListItemIcon>
            Make Payment
          </MenuItem>
        )}

        <MenuItem
          onClick={() => {
            handleTogglePaymentHistoryModal();
            handleActionClose();
          }}
          sx={{ padding: "5px 14px", fontSize: "0.85rem" }}
        >
          <ListItemIcon>
            <FaHistory size={14} />
          </ListItemIcon>
          Payment History
        </MenuItem>
        {userRole == "user" && (
          <>
            <MenuItem
              onClick={() => {
                handleEditModal();
                handleActionClose();
              }}
              sx={{ padding: "5px 14px", fontSize: "0.85rem" }}
            >
              <ListItemIcon>
                <FiEdit2 size={14} />
              </ListItemIcon>
              Edit
            </MenuItem>
            <Divider sx={{ my: 0.3 }} />

            <MenuItem
              onClick={() => {
                handleToggleDelete();
                handleActionClose();
              }}
              sx={{
                padding: "5px 14px",
                fontSize: "0.85rem",
                color: "error.main",
              }}
            >
              <ListItemIcon>
                <FiTrash2 size={12} color="red" />
              </ListItemIcon>
              Delete
            </MenuItem>
          </>
        )}
      </Menu>
    </div>
  );
};

export default Expense;
